
// Progressively enhanced infinite scroller
// Based on: https://codepen.io/kevinpowell/pen/BavVLra
const scrollers = document.querySelectorAll(".image-marquee");

// If a user hasn't opted in for recuded motion, then we add the animation
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  addAnimation();
}

function addAnimation() {
  scrollers.forEach((scroller) => {
    // add data-animated="true" to every `.scroller` on the page
    scroller.setAttribute("data-animated", true);

    // Make an array from the elements within `.scroller-inner`
    const scrollerInner = scroller.querySelector(".image-marquee__scroller");
    const scrollerContent = Array.from(scrollerInner.children);

    // For each item in the array, clone it
    // add aria-hidden to it
    // add it into the `.scroller-inner`
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  });
}

// Detect Scroll Direction
// Based on: https://codepen.io/lehollandaisvolant/pen/ryrrGx

// Initial state
//var scrollPos = 0;
// adding scroll event
//window.addEventListener('scroll', function(){
  // detects new state and compares it with the new one
 // if ((document.body.getBoundingClientRect()).top > scrollPos)
	//	scrollers.forEach((scroller) => {
   //   scroller.setAttribute("data-direction", "right");
   // });
	//else
	//	scrollers.forEach((scroller) => {
   //   scroller.setAttribute("data-direction", "left");
  //  });
	// saves the new position for iteration.
	//scrollPos = (document.body.getBoundingClientRect()).top;
//});